function parseQuotedScalar(value: string): string {
  if (!value.startsWith('"') || !value.endsWith('"')) return value;
  try {
    const parsed: unknown = JSON.parse(value);
    return typeof parsed === "string" ? parsed : value;
  } catch {
    return value;
  }
}

/** Parse simple YAML front matter (key: value lines between --- delimiters). */
export function parseFrontMatter(raw: string): {
  attrs: Record<string, string>;
  body: string;
} {
  const attrs: Record<string, string> = {};
  if (!raw.startsWith("---")) return { attrs, body: raw };
  const end = raw.indexOf("\n---", 3);
  if (end === -1) return { attrs, body: raw };
  for (const line of raw.slice(4, end).split("\n")) {
    const colon = line.indexOf(":");
    if (colon === -1) continue;
    attrs[line.slice(0, colon).trim()] = parseQuotedScalar(
      line.slice(colon + 1).trim()
    );
  }
  return { attrs, body: raw.slice(end + 4) };
}
